import React, { forwardRef, memo, useImperativeHandle, useState } from 'react';

import { useDisclosure } from '@chakra-ui/hooks';

import { useSites } from 'hooks/sites/useSites';

import { washHub } from 'store/slices';

import { updateCollectionPoint } from 'api/location';
import { useMutation, useQueryClient } from 'react-query';

import { successToast } from 'utils/successToast';

import {
  RefType,
  EditCollectionPointProps,
} from './AddCollectionPointModal.props';
import { CollectionPoint } from 'types/location';

import EditCollectionPointModalView from './AddCollectionPointModal.view';

const Container = forwardRef<RefType, EditCollectionPointProps>((_, ref) => {
  const queryClient = useQueryClient();

  const [point, setPoint] = useState<CollectionPoint | null>(null);

  const washHubId = washHub.selectors.useSelectedWashHubId();

  const { data = [], isLoading } = useSites();
  const { isOpen, onOpen, onClose } = useDisclosure();

  useImperativeHandle(
    ref,
    () => ({
      onOpen: (_point) => {
        setPoint(_point);

        onOpen();
      },
    }),
    [onOpen],
  );

  const { mutate, isLoading: isUpdating } = useMutation(updateCollectionPoint, {
    onSuccess: () => {
      successToast('Collection Point Updated Successfully');

      queryClient.invalidateQueries(`fetch-collection-points-${washHubId}`);

      queryClient.invalidateQueries(
        `fetch-collection-points-${washHubId}-select`,
        {
          exact: true,
        },
      );

      onClose();
    },
  });

  const _props = {
    isOpen,
    onClose,
    point,
    isUpdating,
    sites: data,
    onUpdate: async (payload: any) => {
      mutate({
        _id: point?._id,
        ...payload,
      });
    },
    isLoadingSites: isLoading,
  };

  return <EditCollectionPointModalView {..._props} />;
});

const EditCollectionPointModal = memo(Container);

export default EditCollectionPointModal;
